module.exports = __webpack_public_path__ + "static/img/homeBlue.9b78a3cb.png";